export default __webpack_public_path__ + "static/broadcastImg3-61a509fa7d1d1bed93dedf840ea9fdba.webp";